import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Button from '../../../../shared/_TBComponents/Button';
import Input from '../../../../shared/_TBComponents/Input';
import Modal from '../../../../shared/_TBComponents/Modal';
import Text from '../../../../shared/_TBComponents/Text';

const NestedModalContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 100%;
  gap: 10px;
`;

const NestedModalFooter = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

const CONTACT_TYPES = ['addContact', 'editContact', 'deleteContact'];
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ContactNestedModal = ({
  isOpen, onClose, type, contactForm, onContactFormChange, onSave,
}) => {
  const isAddOrEdit = type === 'addContact' || type === 'editContact';
  const emailValue = contactForm.email?.trim() || '';
  const nameValue = contactForm.name?.trim() || '';
  const isEmailInvalid = isAddOrEdit && emailValue.length > 0 && !EMAIL_REGEX.test(emailValue);
  const canSave = type === 'deleteContact'
    || (nameValue.length > 0 && emailValue.length > 0 && !isEmailInvalid);

  return (
    <Modal
      isOpen={isOpen && CONTACT_TYPES.includes(type)}
      onRequestClose={onClose}
      customBorderRadius='8px'
      customPadding='24px'
      customMaxWidth='400px'
      customMinHeight='200px'
      overlayBackgroundColor='rgba(0, 0, 0, 0.75)'
    >
      <NestedModalContent>
        <Text styledTextProps={{ fontSize: '18px', fontWeight: 600, marginBottom: '16px' }}>
          {type === 'addContact' && 'Add Parent/Guardian Contact'}
          {type === 'editContact' && 'Edit Parent/Guardian Contact'}
          {type === 'deleteContact' && 'Delete Parent/Guardian Contact'}
        </Text>
        <Text styledWrapperProps={{ marginBottom: '16px' }}>
          {(type === 'addContact' || type === 'editContact') && 'Enter the full name and email address of the contact you would like to associate with this athlete.'}
          {type === 'deleteContact' && 'Are you sure you want to delete this contact?'}
        </Text>
        {(type === 'addContact' || type === 'editContact') && (
          <>
            <Input
              label='Full Name'
              name='name'
              type='text'
              value={contactForm.name}
              onChange={onContactFormChange}
              placeholder='Full Name'
              fontSize='14px'
              height='38px'
              width='100%'
              styledWrapperProps={{ marginBottom: '12px' }}
            />
            <Input
              label='Email Address'
              name='email'
              type='email'
              value={contactForm.email}
              onChange={onContactFormChange}
              placeholder='email@domain.com'
              fontSize='14px'
              height='38px'
              width='100%'
              error={isEmailInvalid}
              errorMsg='Please enter a valid email address.'
              right='5px'
              top='38px'
              styledPropsInput={{ style: { border: '1px solid #EEEEEE' } }}
            />
          </>
        )}
        <NestedModalFooter>
          <Button
            name='Cancel'
            fontSize='14px'
            txtColor='#757575'
            bgColor='#FFF'
            borderColor='#EEEEEE'
            customBorderRadius='6px'
            styledTextProps={{ fontWeight: 600 }}
            onClick={(e) => { e.preventDefault(); onClose(); }}
          />
          <Button
            name={type === 'deleteContact' ? 'Delete' : 'Save'}
            fontSize='14px'
            txtColor='#FFF'
            bgColor={type === 'deleteContact' ? '#FF0505' : '#444444'}
            borderColor={type === 'deleteContact' ? '#FF0505' : '#444444'}
            customBorderRadius='6px'
            styledTextProps={{ fontWeight: 600 }}
            onClick={(e) => { e.preventDefault(); onSave(); }}
            disabled={!canSave}
          />
        </NestedModalFooter>
      </NestedModalContent>
    </Modal>
  );
};

ContactNestedModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['addContact', 'editContact', 'deleteContact']),
  contactForm: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
  }),
  onContactFormChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

ContactNestedModal.defaultProps = {
  type: null,
  contactForm: { name: '', email: '' },
};

export default ContactNestedModal;
